import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { KeyRound, Loader2, AlertCircle, LogOut } from "lucide-react";
import { toast } from "sonner";

export default function ChangePasswordPage() {
  const { user, changePassword, logout } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (f.new_password.length < 8) { setErr("La nuova password deve avere almeno 8 caratteri"); return; }
    if (f.new_password !== f.confirm) { setErr("Le due nuove password non coincidono"); return; }
    if (f.new_password === f.current_password) { setErr("La nuova password deve essere diversa dalla precedente"); return; }
    setBusy(true);
    try {
      await changePassword(f.current_password, f.new_password);
      toast.success("Password aggiornata con successo");
      nav("/", { replace: true });
    } catch (e) {
      setErr(e.response?.data?.detail || "Errore durante il cambio password");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 shadow-2xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="emmepi-logo-mark">M</div>
          <div>
            <div className="text-lg font-extrabold text-slate-900">emmepigroup</div>
            <div className="text-xs text-slate-500 uppercase tracking-wider">Cambio password</div>
          </div>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-1">Imposta la tua password</h1>
        <p className="text-sm text-slate-600 mb-6">Benvenuto <span className="font-semibold">{user?.nome}</span>. Al primo accesso è obbligatorio impostare una password personale.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Password attuale</Label>
            <Input type="password" required autoFocus value={f.current_password} onChange={e => setF({ ...f, current_password: e.target.value })} data-testid="pwd-current" />
          </div>
          <div>
            <Label>Nuova password (min 8 caratteri)</Label>
            <Input type="password" required minLength={8} value={f.new_password} onChange={e => setF({ ...f, new_password: e.target.value })} data-testid="pwd-new" />
          </div>
          <div>
            <Label>Conferma nuova password</Label>
            <Input type="password" required minLength={8} value={f.confirm} onChange={e => setF({ ...f, confirm: e.target.value })} data-testid="pwd-confirm" />
          </div>
          {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2 flex items-center gap-2"><AlertCircle className="w-4 h-4" /> {err}</div>}
          <Button type="submit" disabled={busy} className="w-full bg-blue-700 hover:bg-blue-800" data-testid="pwd-submit">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <KeyRound className="w-4 h-4 mr-2" />} Aggiorna password
          </Button>
          <button type="button" onClick={logout} className="w-full text-xs text-slate-500 hover:text-slate-700 flex items-center justify-center gap-1 mt-2">
            <LogOut className="w-3 h-3" /> Annulla ed esci
          </button>
        </form>
      </Card>
    </div>
  );
}
